var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../../../templates/components/appliances/cooking.template.html');
require('../../../../libs/handlebars/handlebars-helpers.ts');

var TheView = GenericView.extend({
    el: '#cooking',
    tagName: '',
	template: Handlebars.compile(Template),
	initialize: function (options) {
        this.render();
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        var params = {
            appliances: [
                {"electric_appliance": "Electric hob", "applianceType": "Electric_Hob", "cycle_power": 2400, "stand_by_power": 1.0.toFixed(2), "cycle_power_factor": 0.98, "cycle_duration": 16, "stand_by_duration":  0},
                {"electric_appliance": "Electric oven", "applianceType": "Electric_Oven", "cycle_power": 2125, "stand_by_power": 3.0.toFixed(2), "cycle_power_factor": 0.98, "cycle_duration": 27, "stand_by_duration":  0},
                {"electric_appliance": "Microwave oven", "applianceType": "Microwave_Oven", "cycle_power": 1250, "stand_by_power": 2.0.toFixed(2), "cycle_power_factor": 0.98, "cycle_duration": 7, "stand_by_duration":  0},
                {"electric_appliance": "Electrical Kettle", "applianceType": "Kettle", "cycle_power": 2000, "stand_by_power": 1.0.toFixed(2), "cycle_power_factor": 0.98, "cycle_duration": 3, "stand_by_duration":  0},
                {"electric_appliance": "Grill", "applianceType": "Grill", "cycle_power": 2000, "stand_by_power": 1.0.toFixed(2), "cycle_power_factor": 0.98, "cycle_duration": 22, "stand_by_duration":  0},
                {"electric_appliance": "Coffee maker", "applianceType": "Coffee_Maker", "cycle_power": 1000, "stand_by_power": 1.6.toFixed(2), "cycle_power_factor": 0.75, "cycle_duration": 8, "stand_by_duration":  0},
                {"electric_appliance": "Deep Fryer", "applianceType": "Deep_Fryer", "cycle_power": 1800, "stand_by_power": 0.0.toFixed(2), "cycle_power_factor": 0.98, "cycle_duration": 20, "stand_by_duration":  0},
                {"electric_appliance": "Steam Cooker", "applianceType": "Steam_Cooker", "cycle_power": 736, "stand_by_power": 2.0.toFixed(2), "cycle_power_factor": 0.98, "cycle_duration": 53, "stand_by_duration":  0},
                {"electric_appliance": "Toaster", "applianceType": "Toaster", "cycle_power": 1000, "stand_by_power": 1.0.toFixed(2), "cycle_power_factor": 0.98, "cycle_duration": 5, "stand_by_duration":  0},
                {"electric_appliance": "Blender/Juicer", "applianceType": "Food_Processor", "cycle_power": 350, "stand_by_power": 1.5.toFixed(2), "cycle_power_factor": 0.8.toFixed(2), "cycle_duration": 6, "stand_by_duration":  0},
                {"electric_appliance": "Electric mixer", "applianceType": "Electric_Mixer", "cycle_power": 190, "stand_by_power": 0.0.toFixed(2), "cycle_power_factor": 0.8.toFixed(2), "cycle_duration": 3, "stand_by_duration":  0},
                {"electric_appliance": "Kitchen Extractor", "applianceType": "Kitchen_Extractor", "cycle_power": 144, "stand_by_power": 1.0.toFixed(2), "cycle_power_factor": 0.6.toFixed(2), "cycle_duration": 45, "stand_by_duration":  0}
            ]
        };

        this.$el.html(this.template(params));
    },
    getCookingAppliances: function() {
        var cooking_appliances = [];

        var rows = $("#cookingTable tbody").find("tr");
        $.each(rows, function(index, value) {
            var temp = {
                electric_appliance: $(this).find(".electric_appliance").html(),
                cycle_power: parseFloat($(this).find(".cycle_power").html()),
                stand_by_power: parseFloat($(this).find(".stand_by_power").html()),
                cycle_power_factor: parseFloat($(this).find(".cycle_power_factor").html()),
                cycle_duration: parseFloat($(this).find(".cycle_duration").html()),
                stand_by_duration: parseFloat($(this).find(".stand_by_duration").html()),
                applianceType: $(this).find(".electric_appliance").data("appliance-type")
            }
            cooking_appliances.push(temp);
        });

        return cooking_appliances;
    }
});

module.exports= TheView;